function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M10.326 7.674a1.875 1.875 0 11-2.652 2.652 1.875 1.875 0 012.652-2.652"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M11.137 3.09l.437.145c.4.134.671.509.671.931v.628c0 .534.426.97.96.98l.629.014a.981.981 0 01.856.543l.207.412a.98.98 0 01-.184 1.133l-.444.444a.981.981 0 00-.015 1.372l.435.455a.98.98 0 01.222.989l-.146.437a.982.982 0 01-.93.671h-.628a.98.98 0 00-.981.96l-.014.629a.981.981 0 01-.542.856l-.412.207a.98.98 0 01-1.133-.184l-.444-.444a.981.981 0 00-1.372-.015l-.455.435a.98.98 0 01-.99.222l-.436-.146a.982.982 0 01-.672-.93v-.628a.98.98 0 00-.96-.981l-.628-.014a.981.981 0 01-.857-.542l-.206-.412a.98.98 0 01.184-1.133l.444-.444a.981.981 0 00.015-1.372l-.435-.455a.981.981 0 01-.223-.99l.146-.437a.982.982 0 01.93-.671h.628a.98.98 0 00.981-.96l.014-.629a.985.985 0 01.543-.856l.412-.207a.98.98 0 011.133.184l.444.444a.981.981 0 001.372.015l.455-.435a.982.982 0 01.989-.221v0z",
  clipRule: "evenodd"
}));